import { create , update} from '../../_services/client_percent';

export const createClientPercentEvent = async (clientUpdate,percent) => {   
    if(! clientUpdate ) throw new Error('No hay un cliente especificado');
    let body={
        clientUpdate,
        percent
    }
    let res = await create(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const updateClientPercentEvent = async (clientPercent,percent) => {   
    if(! clientPercent) throw new Error('No hay un porcentaje para actualizar');    
    let body={
        clientPercent,
        percent
    }
    let res = await update(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}